export const VUE_APP_AJAX_BASE_URL =  process.env.VUE_APP_AJAX_BASE_URL;
export const VUE_APP_AJAX_TIMEOUT = process.env.VUE_APP_AJAX_TIMEOUT;
export const VUE_APP_TITLE = process.env.VUE_APP_TITLE;
export const VUE_APP_MOBILE_WIDTH = process.env.VUE_APP_MOBILE_WIDTH;
export const VUE_APP_IMG_URL = process.env.VUE_APP_IMG_URL;